import React from "react";
import classes from "./ContentTabs.module.css";

const ContentTabs = ({ tabsName, tabs, activeTab, onTabChange, children }) => {
    const activeIndex = tabs.findIndex((t) => t.id === activeTab);

    return (
        <div className={classes.Tabs}>
            <div role="tablist" aria-label={tabsName} className={classes.TabBar}>
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        role="tab"
                        id={`${tabsName}-tab-${tab.id}`}
                        aria-selected={activeTab === tab.id}
                        aria-controls={`${tabsName}-panel-${tab.id}`}
                        onClick={() => onTabChange(tab.id)}
                        className={`${classes.Tab} ${activeTab === tab.id ? classes.TabActive : ""}`}
                    >
                        <span className={classes.TabLabel}>{tab.label}</span>
                        <div className={`${classes.TabUnderline} ${activeTab === tab.id ? classes.TabUnderlineActive : ""}`} />
                    </button>
                ))}
            </div>

            <div
                role="tabpanel"
                id={`${tabsName}-panel-${tabs[activeIndex]?.id}`}
                aria-labelledby={`${tabsName}-tab-${tabs[activeIndex]?.id}`}
            >
                {typeof children === "function" ? children(activeTab) : children}
            </div>
        </div>
    );
};

export default ContentTabs;
